import { AxiosRequestConfig } from 'axios';
import { PAGES } from 'common/enums';

class DocumentTypeRequestConfig {
  getDocumentTypeByApPage = (pageUrl: PAGES): AxiosRequestConfig => ({
    method: 'POST',
    url: 'documenttype/getDocumentTypeByApPage',
    data: { pageUrl }
  });
}

export const documentTypeRequestConfig = new DocumentTypeRequestConfig();
